import React from "react";

const SummaryCard = ({ title, description, value }) => {
  return (
    <div className="submission_preview__card">
      <div className="submission_preview__card__content flex-fill justify-content-between">
        <div className="submission_preview__subtitle">{title}</div>
        {description && <div className="submission_preview__description">{description}</div>}
        <div className="submission_preview__stat_value">{value}</div>
      </div>
    </div>
  );
};

export default SummaryCard;
